import StrokeSmall from '../../assets/images/stroke-small.svg';
import StrokeMedium from '../../assets/images/stroke-medium.svg';
import StrokeLarge from '../../assets/images/stroke-large.svg';
import CrayonSmall from '../../assets/images/crayon-sm.svg';
import CrayonSmallMobile from '../../assets/images/mobile/crayon-sm-mb.svg';
import ProgressCheck from '../../assets/images/progress-check.svg';
import ProgressArrow from '../../assets/images/progress-arrow.svg';
import classNames from 'classnames';

function ProgressBarEnd({ pageNumber, isIntro }: { pageNumber: number; isIntro: boolean; }) {
    return (
        <div className="flex flex-col-reverse md:flex-col items-center relative left-6 md:left-0">
            <img
                alt=""
                key={`crayon${pageNumber}`}
                src={CrayonSmall}
                className={classNames(
                    "hidden md:flex relative h-12 w-12 bottom-[6px]",
                    isIntro ? 'right-2' : 'crayon-animate right-6'
                )}
            />
            <img
                alt=""
                key={`crayonmobile${pageNumber}`}
                src={CrayonSmallMobile}
                className={classNames(
                    "relative md:hidden h-[20px] w-[53px] bottom-[6px]",
                    isIntro ? 'right-8' : 'crayon-mobile-animate right-[22px]'
                )}
            />
            <div
                className={classNames(
                    "border h-4 w-4 rounded-full relative bottom-[2px] md:bottom-3 right-11",
                    isIntro ? 'bg-transparent border-transparent' : 'bg-crayola-pink border-grey-300'
                )}>
            </div>
            <div
                key={`slug${pageNumber}`}
                className={classNames(
                    "bg-crayola-pink font-semibold rounded h-6 w-[54px] text-white text-lg flex justify-center items-center relative bottom-[3px] md:bottom-2",
                    isIntro ? 'right-[52px] md:right-7' : 'slug-animate right-11'
                )}
            >
                {isIntro ? 'Start' : `${(pageNumber + 1) * 10}%`}
            </div>
        </div>
    );
}

export function ProgressBar({
    pageNumber,
    onProgressClick,
    onRestart,
    isIntro
}: { 
    pageNumber: number;
    onProgressClick: (pageNumber: number) => void;
    onRestart: () => void;
    isIntro: boolean;
}) {
    return (
        <nav role="navigation" className={classNames(
            navigator.userAgent.includes('iPhone') && navigator.userAgent.includes('Safari') && 'iphone',
            "progress-bar h-12 z-50 bg-crayola-pale-pink w-full md:h-[92px] md:bg-transparent fixed bottom-0 justify-center flex items-center flex-col gap-3 md:flex md:relative"
        )}>
            <div className="w-[380px] md:w-[751px] lg:w-[1080px] h-1 bg-crayola-dark-gray rounded-2xl flex relative items-center overflow-visible">
                {isIntro && <div className="flex relative items-center">
                    <img className="relative bottom-[1px] start-[1px]" src={StrokeSmall} alt="" />
                    <div className="bg-crayola-dark-pink rounded-full h-4 w-4 absolute"></div>
                </div>}
                {!isIntro && [...Array(pageNumber + 1)].map((key, i) => <div key={`progress-${i}`} className="flex relative items-center md:right-3">
                    <img className="hidden stroke-animate lg:flex w-auto relative bottom-[1px] start-[1px]" src={StrokeLarge} alt="" />
                    <img className="hidden stroke-animate md:flex lg:hidden w-auto relative bottom-[1px] start-[1px]" src={StrokeMedium} alt="" />
                    <img className="flex stroke-animate md:hidden relative bottom-[1px] start-[1px] w-[36px]" src={StrokeSmall} alt="" />
                    <button
                        role="link"
                        aria-label={i === 0 ? 'Back to Start' : `Back to ${i * 10}%`}
                        className="progress-button group absolute w-4 h-4 rounded"
                        onClick={() => {
                            i === 0 ? onRestart() : onProgressClick(i - 1)
                        }}
                    >
                        <img className="absolute left-0 bottom-0 opacity-100 group-hover:opacity-0 group-focus:opacity-0" alt="" src={ProgressCheck} />
                        <img className="absolute left-0 bottom-0 opacity-0 group-hover:opacity-100 group-focus:opacity-100" alt="" src={ProgressArrow} />
                        <div
                            key={`focusslug${pageNumber}`}
                            className={classNames(
                                "hidden md:group-hover:flex md:group-focus:flex bg-crayola-pale-pink font-semibold rounded h-6 w-[54px] text-crayola-dark-pink text-lg justify-center items-center absolute bottom-[3px] md:-right-5 md:top-[19.5px]",
                            )}
                        >
                            {i === 0 ? 'Start' : `${(i) * 10}%`}
                        </div>
                    </button>
                </div>)}
                <ProgressBarEnd pageNumber={pageNumber} isIntro={isIntro} />
            </div>
        </nav>
    );
}